// removed by extract-text-webpack-plugin
module.exports = {"isLoading":"_2Cl4t","wrapper":"_3S7gg","icon":"V0c2o","labelText":"_6Csfk","option":"_2KCe1","error":"_3GnGL","errorText":"_1e0FU"};


//////////////////
// WEBPACK FOOTER
// ./components/form/ChoiceField/styles.scss
// module id = 707
// module chunks = 0